import type { ThemeDefinition } from './types';

export const koodookaDark: ThemeDefinition = {
  id: 'koodooka-dark',
  name: 'Koodooka (Dark)',
  description: 'Koodooka brand dark theme — graphite surfaces, bone typography, and terracotta accents',
  mode: 'dark',
  tokens: {
    colorPrimary: '#D66A53',
    colorPrimaryOnSidebar: '#D66A53',
    colorPrimaryHover: '#E27C66',
    colorPrimaryActive: '#BC533F',
    colorPrimaryBg: '#321D19',
    colorFocus: '#D66A53',
    colorSecondary: '#C6C1BC',
    colorAccent: '#D66A53',
    colorSuccess: '#4DAA7E',
    colorWarning: '#D0A14A',
    colorError: '#E06B6B',
    colorInfo: '#7EA3CB',
    colorBgBase: '#0F0F11',
    colorBgContainer: '#161618',
    colorBgElevated: '#1D1D20',
    colorBgSidebar: '#121214',
    colorText: '#F4F2EE',
    colorTextSecondary: '#C1BCB6',
    colorTextTertiary: '#918C87',
    colorTextOnChrome: '#F4F2EE',
    colorTextInverse: '#111113',
    colorBorder: '#2C2B2F',
    colorBorderSecondary: '#242327',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.32), 0 12px 30px rgba(0, 0, 0, 0.16)',
    boxShadowSecondary: '0 20px 56px rgba(0, 0, 0, 0.42), 0 2px 10px rgba(0, 0, 0, 0.24)',
    glassBlur: '20px',
    glassOpacity: '0.84',
    glassContentOpacity: '0.90',
    glassModalOpacity: '0.88',
    glassSaturation: '125%',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontFamilyHeading: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontFamilyDisplay: '"Instrument Serif", Georgia, serif',
    fontFamilyMono: '"SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Menlo, Consolas, monospace',
    fontSize: 14,
    fontSizeHeading: 22,
    borderRadius: 10,
    borderRadiusLG: 14,
    cardBorder: '#2C2B2F',
    cardShadow: '0 1px 2px rgba(0, 0, 0, 0.30)',
  },
};
